<app-content-library [contentTypes]="contentTypes"></app-content-library>
